import React, { useEffect, useRef } from 'react';

export function AppearDetector({
  onIntersect,
  scrollContainerId,
}: {
  onIntersect?: (intersect: boolean) => void;
  scrollContainerId?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scrollContainerId) return;

    const scrollContainer = document.getElementById(scrollContainerId);

    if (!scrollContainer || !ref.current) return;

    const handleResize = () => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const isIntersect = ref.current!.getBoundingClientRect().y - window.innerHeight < -50;

      onIntersect?.(isIntersect);
    };
    scrollContainer.addEventListener('scroll', handleResize);

    return () => {
      scrollContainer.removeEventListener('scroll', handleResize);
    };
  }, [onIntersect, scrollContainerId]);

  return <div ref={ref}></div>;
}
